import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import Fantasy from "../pages/fantasy/page";
import Campus from "../pages/campus/page";
import Romance from "../pages/romance/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "fantasy", element: <Fantasy /> },
      { path: "campus", element: <Campus /> },
      { path: "romance", element: <Romance /> },
      { path: "about", element: <About /> },
      { path: "faq", element: <Faq /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;